export default () => ENV.RELEASE_STAGE === 'development' ? 'https://www.hypotheekbond.test/' : 'https://www.hypotheekbond.nl/';
